<template>
	<v-container v-if="config.ORIGIN === 'SOUNDPLUS'"
		id="home" class="fill-height flex-column flex-nowrap" :fluid="true">
		<div class="align-self-end">
			<v-btn class="mr-3" density="comfortable" size="x-large" variant="outlined" color="white"
				:href="config.SUPPORT_URL">
				Help & Training
			</v-btn>
			<v-btn class="mr-3" density="comfortable" size="x-large" variant="outlined" color="white"
				href="https://lyra-dashboard-ui.prognplay-ihm.com/">
				AirChecks
			</v-btn>
			<v-btn class="mr-3" density="comfortable" size="x-large" variant="outlined" color="white"
				:href="config.CONSOLE_URL">
				Sound+ Studio
			</v-btn>
			<v-btn class="mr-3" density="comfortable" size="x-large" variant="outlined" color="white"
				@click="SignIn">
				Login
			</v-btn>
		</div>
		<h1 class="mt-12 text-white">
			Need Help? Wanna Learn Sound+? Check out the Help & Training
		</h1>
		<div class="d-flex align-center fill-height">
			<div>
				<v-img src="@/assets/images/white_soundplus_logo_withtagline.png"/>
				<div class="live-console-text">
					Live Console
				</div>
			</div>
		</div>
		<h3 class="pb-12 text-white">
			ATTENTION! PLEASE MAKE SURE THE CORRECT AUDIO DEVICE IS CONNECTED TO THIS COMPUTER BEFORE LOGGING IN! IF
			NOT, PLEASE CONNECT IT NOW, THEN REFRESH THE BROWSER.
		</h3>
		<div class="align-self-end">
			<v-img src="@/assets/images/iHeartMedia_Logo_Horizontal_White.png" height="45" width="309"/>
		</div>
	</v-container>
	<v-container v-else id="home" class="zettacloud fill-height flex-column justify-center" :fluid="true">
		<SnackbarNotification/>
		<div class="logo-container">
			<a href="/">
				<Image img="zettacloud_login_logo.svg" width="180" height="40" eager/>
			</a>
		</div>

		<div class="form-container">
			<header class="welcome-header">
				<h1>Log in</h1>
				<p>Welcome back!</p>
			</header>

			<v-form v-if="!retrievingAccessToken" id="login-form" name="login-form" v-model="valid"
				class="d-flex flex-column justify-space-between" @submit.prevent.once="SignIn">
				<div>
					<v-text-field v-model="email"
						name="email"
						label="*Email address"
						variant="outlined"
						density="comfortable"
						rounded="lg"
						base-color="rgba(255, 255, 255, 0.7)"
						bg-color="rgb(50, 50, 50)"
						color="rgb(141, 56, 149)"
						:rules="[v => !!v || 'This is not a valid e-mail']"
					/>
				</div>
				<div>
					<v-btn class="v-btn--has-bg"
						height="48"
						width="110"
						rounded="xl"
						:disabled="!valid"
						@click.once.prevent="SignIn">
						Continue
					</v-btn>
				</div>
			</v-form>
		</div>

		<div class="footer-container">
			<a href="https://www.rcsworks.com/privacy-policy/" target="_blank">
				<span>
					Privacy Policy
				</span>
			</a>
			<span>
				|
			</span>
			<a href="https://www.rcsworks.com/terms-of-use/" target="_blank">
				<span>
					Terms of Use
				</span>
			</a>
		</div>
	</v-container>
</template>

<script>
import SessionManagerLoader from "@/services/SessionManagerLoader";
import config from "@/config";
import Image from "@/components/Image.vue";
import SnackbarNotification from "@/components/SnackbarNotification.vue";

export default {
	name: "HomePage",
	components: {Image, SnackbarNotification},

	data() {
		return {
			email: null,
			valid: true
		}
	},

	computed: {
		config() {
			return config;
		},

		retrievingAccessToken() {
			return window.location.pathname === "/auth/callback";
		}
	},

	async created() {
		this.SessionManager = await SessionManagerLoader();
		this.SessionManager.InitSession();
	},

	methods: {
		SignIn() {
			this.SessionManager.SignIn(config.ORIGIN === "ZETTACLOUD" && this.email);
		}
	}
};
</script>

<style lang="scss" scoped>

#home {
	background: var(--login-background);

	&.zettacloud {
		.logo-container {
			left: 4rem;
			position: absolute;
			top: 4rem;
		}

		.form-container {
			width: 20rem;

			.welcome-header {
				margin-bottom: 3rem;

				h1 {
					color: white;
					margin: 0 0 .5rem;
					font-size: 34px;
					font-weight: 400;
				}

				p {
					margin: 0;
					color: #a1a1aa;
				}
			}

			.v-form {
				height: 140px;

				:deep(.v-field) {
					font-size: 16px;

					:-webkit-autofill,
					:-webkit-autofill:hover,
					:-webkit-autofill:focus,
					:-webkit-autofill:active {
						-webkit-text-fill-color: white !important;
						-webkit-background-clip: text;
					}
				}

				.v-btn {
					color: $ihm-white;
					background-color: rgb(141, 56, 149);

					&.v-btn--disabled {
						background-color: rgb(117, 117, 117);
					}
				}
			}
		}

		.footer-container {
			position: absolute;
			bottom: 0;
			background: transparent;
			font-size: 14px;
			padding: 10px;
			color: rgb(87, 88, 97);

			a {
				color: inherit;
				text-decoration: none;
			}

			a:hover {
				color: rgb(141, 56, 149);
			}

			span {
				color: inherit;
			}
		}
	}
}

.live-console-text {
	font-family: Helvetica;
	font-size: 7em;
	letter-spacing: 0.03em;
	color: white
}
</style>